import axios from 'axios';

// Получаем текущий домен из браузера
const getDomain = () => {
  if (typeof window !== 'undefined') {
    const protocol = window.location.protocol;
    const hostname = window.location.hostname;
    return {
      http: `${protocol}//${hostname}:${process.env.REACT_APP_API_PORT || ''}`,
      ws: `${protocol === 'https:' ? 'wss:' : 'ws:'}//${hostname}:${process.env.REACT_APP_WS_PORT || ''}/ws`
    };
  }
  return {
    http: 'http://localhost:3030',
    ws: 'ws://localhost:3030'
  };
};

// Базовый URL для API
const BASE_URL = process.env.REACT_APP_API_BASE_URL || getDomain().http;

// Базовый URL для веб-сокетов
const WS_BASE_URL = process.env.REACT_APP_WS_BASE_URL || `${getDomain().ws}`;

// Add response interceptor
axios.interceptors.response.use(
  (response) => {
    // Any status code within the range of 2xx cause this function to trigger
    return response;
  },
  (error) => {
    // Any status codes outside the range of 2xx cause this function to trigger
    console.error("API Error:", error);
    return Promise.reject(error);
  }
);

export { BASE_URL, WS_BASE_URL };